import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home.jsx';
import Start from './pages/Start.jsx';
import VitamdStart from './pages/VitamdStart.jsx';
import Connect from './pages/Connect.jsx';
import Media from './pages/Media.jsx';
import Admin from './pages/Admin.jsx';
import Layout from './components/Layout.jsx';

// Route paths must never contain a health-CONDITION name (diabetes, ED, low-T, etc.).
// `/betterhealth` is the neutral, whole-body landing — fits the broadened mission
// and stays clear of condition/weight language in the ad final URL.
// `/`             → VitaMD brand homepage (story, physicians, forum, about).
// `/start`        → Alfred Voice AI intake (single-voice men's-health).
// `/betterhealth` → VitaMD two-AI landing (ad destination); /weight-loss + /vitamd redirect here.
// `/admin`        → editorial pipeline dashboard (HTTP Basic, no chrome).
export default function App() {
  return (
    <Routes>
      {/* Admin sits outside <Layout/> — no marketing header/footer. */}
      <Route path="admin" element={<Admin />} />

      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="start" element={<Start />} />
        {/* VitaMD two-AI landing (ad destination). /weight-loss + /vitamd redirect here. */}
        <Route path="betterhealth" element={<VitamdStart />} />
        <Route path="weight-loss" element={<Navigate to="/betterhealth" replace />} />
        <Route path="vitamd" element={<Navigate to="/betterhealth" replace />} />
        <Route path="journey" element={<Navigate to="/start" replace />} />
        <Route path="connect" element={<Connect />} />
        <Route path="media" element={<Media />} />
        <Route path="news" element={<Navigate to="/media" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
